/**
 * Route for `igaming-deposit-tracking`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { IgamingDepositTrackingPage } from "../features/igaming-deposit-tracking/IgamingDepositTrackingPage";

export const igamingDepositTrackingRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/igaming-deposit-tracking",
	component: IgamingDepositTrackingPage,
});

export default igamingDepositTrackingRoute;
